import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  FormGroup,
  FormLabel,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CardContent,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { APP_STATE_ACTION_TYPE_USER_FONT, APP_STATE_ACTION_TYPE_USER_FONT_SIZE } from '../../state/seed-states';
import { settingsSettingablesPropTypes, defaultSettingsSettingablesPropTypes } from './settings-page-prop-types';

const SeedFontSettings = ({
  font,
  supportedFonts,
  fontSize,
  supportedFontSizes,
  onChangeSettings,
  settingables,
}) => (
  <Card>
    <CardContent>
      <Box p={1}>
        <Typography variant="h5">
          <FormattedMessage
            id="seed.settings.heading.font"
          />
        </Typography>
        <Box p={1}>
          <FormGroup>
            {
              settingables[APP_STATE_ACTION_TYPE_USER_FONT]
                ? (
                  <>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">
                        <FormattedMessage
                          id="seed.settings.label.fontFamily"
                        />
                      </FormLabel>
                      <RadioGroup
                        aria-label="font"
                        name="font"
                        value={font}
                        onChange={(event) => onChangeSettings(
                          APP_STATE_ACTION_TYPE_USER_FONT, event.target.value, 'string',
                        )}
                      >
                        {
                        supportedFonts.map((fo) => (
                          <FormControlLabel
                            key={`settings-font-${fo}`}
                            value={fo}
                            control={<Radio size="small" color="primary" />}
                            label={fo}
                          />
                        ))
                        }
                      </RadioGroup>
                    </FormControl>
                    <Box mt={1} />
                  </>
                ) : ''
            }
            {
              settingables[APP_STATE_ACTION_TYPE_USER_FONT_SIZE]
                ? (

                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <FormattedMessage
                        id="seed.settings.label.fontSize"
                      />
                    </FormLabel>
                    <RadioGroup
                      aria-label="fontSize"
                      name="fontSize"
                      value={fontSize}
                      onChange={(event) => onChangeSettings(
                        APP_STATE_ACTION_TYPE_USER_FONT_SIZE, parseInt(event.target.value, 10), 'int',
                      )}
                    >
                      {
                        supportedFontSizes.map((fs) => (
                          <FormControlLabel
                            key={`settings-fontSize-${fs}`}
                            value={fs}
                            control={<Radio size="small" color="primary" />}
                            label={<FormattedMessage id={`font-size-${fs}`} />}
                          />
                        ))
                      }
                    </RadioGroup>
                  </FormControl>
                ) : ''
            }
          </FormGroup>
        </Box>
      </Box>
    </CardContent>
  </Card>
);

SeedFontSettings.propTypes = {
  font: PropTypes.string.isRequired,
  supportedFonts: PropTypes.arrayOf(PropTypes.string).isRequired,
  fontSize: PropTypes.number.isRequired,
  supportedFontSizes: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChangeSettings: PropTypes.func.isRequired,
  settingables: settingsSettingablesPropTypes,
};

SeedFontSettings.defaultProps = {
  settingables: defaultSettingsSettingablesPropTypes,
};

export default SeedFontSettings;
